<template>
    <div class="service-listing">
        <div class="container">
            <div class="row">
                <!--tabs filter-->
                <div class="col-12">
                    <b-tabs content-class="mt-3" justified>
                        <b-tab v-for="tab in tabs"
                               :key="tab.id"
                               :title="tab.title"
                               @click="tabChange(tab.id)">
                        </b-tab>
                    </b-tabs>
                </div>

                <!--filter component-->
                <div class="col-xs-3 col-lg-3 responsive-cancel-padding cancel-left-padding">
                    <div class="filter-component">
                        <filterservice :apiResponse="info"
                                       :FilterByDate="FilterByDate"
                                       :filter="filterData"
                                       @depArr="depArr = $event"
                                       @categoryArr="cateArr = $event"
                                       @sectorArr="sectorArr = $event"
                                       @subArr="subArr = $event"
                                       @healthArr="healthArr = $event"
                                       @funcArr="funcArr = $event"
                                       @tarckApplyFilter="tarckApplyFilter = true"
                                       :PageType="PageType"
                                       :rules="rules"
                                       :announcement="announcement"
                                       :services="services"
                                       v-if="info && services"
                                       :sectorLab="SectorLabel"
                                       :categoryLab="CategoryLabel"
                                       :productLab="ProductsLabel"
                                       :functionsLab="FunctionsLabel"
                                       :searchLab="SearchLabel"
                                       :CategoriesOfRules="CategoriesOfRules"
                                       @datestart="datestart = $event"
                                       @dateend="dateend = $event"
                                       @resetDate="resetDate = $event"
                                       :ClearDateFilter="ClearDateFilter"
                                       :Apply="Apply"
                                       :Reset="Reset"
                                       :From="From"
                                       :key="reinitFilter"
                                       :To="To"
                                       :BackBtn="BackBtn"
                                       :Required="Required" />
                        <div class="generic-loader filter-loader" v-if="apiCallLoader">
                            <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="contact">
                    <!--Rules And Regulations component-->
                    <div class="accordion-wrapper">
                        <h3 v-if="contactNoData" class="empty-msg">
                            {{ NoResultMessage }}
                        </h3>
                        <div class="table-div" v-if="data.Contact.length != 0">
                            <div class="service-table dep-table table-responsive">
                                <table class="table table-bordered contact-table">
                                    <tbody>
                                        <tr>
                                            <th>{{ ContactTitle }}</th>
                                            <th>{{ Phone }}</th>
                                            <th>{{ Email }}</th>
                                            <th>{{ Address }}</th>
                                        </tr>
                                        <tr v-for="(contact, index) in data.Contact" :key="index">
                                            <td>{{ contact.ContactTitle }}</td>
                                            <td> <a :href="`tel:${contact.Phone}`">{{ contact.Phone }}</a> </td>
                                            <td>
                                                <a :href="`mailto:${email}`" v-for="(email, index) in contact.Email" :key="index">
                                                    {{ email }} 
                                                </a>
                                            </td>
                                            <td>{{ contact.Address }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12" v-if="specializations">
                    <div class="accordion-wrapper">
                        <h3 v-if="specializationsNoData" class="empty-msg">
                            {{ NoResultMessage }}
                        </h3>
                        <div class="services-details"
                             v-if="data.Specializations.length != 0">
                            <div class="services-details-steps"
                                 v-for="(specialization, index) in data.Specializations"
                                 :key="index">
                                <div class="services-details-steps-number">
                                    <p>{{ index + 1 }}</p>
                                </div>
                                <div class="services-details-steps-text">
                                    <p>
                                        {{ specialization.Title }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-9 col-lg-9 responsive-cancel-padding"
                     v-if="services">
                    <div class="accordion-wrapper">
                        <!--search component-->
                        <servicesearch @searchKeyword="(searchWord = $event), (searchClicked = true)"
                                       :searchFilter="filterData"
                                       :searchLab="SearchLabel"
                                       :searchPlaceHolder="SearchPlaceHolder"
                                       :key="reinitFilter"
                                       v-if="services" />

                        <!--loader-->
                        <div class="generic-loader" v-show="isAjaxLoading">
                            <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                        </div>

                        <!--services component-->
                        <div class="accordion"
                             id="accordionExample"
                             aria-multiselectable="true"
                             v-if="services">
                            <h3 v-if="servicesNoData" class="empty-msg">
                                {{ NoResultMessage }}
                            </h3>
                            <div v-if="!servicesNoData">
                                <Service-card :serviceCardObj="serviceObj"
                                              :serviceCardArr="filteredData"
                                              :mobileView="mobileView"></Service-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import filterservice from "../GenericPageComponent/Filter/FilterService.vue";
    import servicesearch from "../GenericPageComponent/ServiceSearch/ServiceSearch.vue";
    import ServiceCard from "../GenericListingComponent/ServicesBlock/ServiceCard.vue";
    import Vue from "vue";
    import axios from "axios";
    import BTab from 'bootstrap-vue';

    Vue.use(BTab, axios);

    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let language = window.CurrentLanguage.CurrentLanguage;

    export default {
        props: [
            "FilterByDate",
            "SectorLabel",
            "CategoryLabel",
            "ProductsLabel",
            "FunctionsLabel",
            "SearchLabel",
            "SearchPlaceHolder",
            "PageType",
            "tabs",
            "ClearDateFilter",
            "From",
            "To",
            "Required",
            "NoResultMessage",
            "Apply",
            "Reset",
            "ServiceCost",
            "CentralAdministration",
            "PublicAdministration",
            "CategoriesOfRules",
            "Specialization",
            "Cosmetic",
            "SecondaryCategory",
            "Category",
            "sectorId",
            "Email",
            "Phone",
            "Address",
            "ContactTitle",
            "BackBtn"
        ],
        components: {
            filterservice,
            servicesearch,
            ServiceCard
        },
        data() {
            return {
                tabIndex: 0,
                pageNumber: 1,
                searchWord: "",
                info: null,
                data: {
                    Specializations: [],
                    Services: [],
                    Contact: [],
                    Brief: "",
                    Id: "",
                    Name: ""
                },
                cateArr: [],
                sectorArr: [],
                subArr: [],
                healthArr: [],
                funcArr: [],
                depArr: [],
                tarckApplyFilter: false,
                searchClicked: false,
                isAjaxLoading: true,
                filteredData: {
                    Services: [],
                },
                limit: 10,
                pageLoad: true,
                rules: false,
                services: false,
                specializations: true,
                contact: false,
                announcement: false,
                mobileView: false,
                reinitFilter: 0,
                filter: [],
                tabClicked: false,
                serviceObj: {},
                servicesNoData: false,
                specializationsNoData: false,
                announcementNoData: false,
                contactNoData: false,
                apiCallLoader: false
            };
        },
        methods: {
            tabChange(id) {
                this.tabClicked = true;
                this.services = false;
                this.specializations = false;
                this.contact = false;
                if (id == 0) {
                    this.specializations = true;
                }
                if (id == 1) {
                    this.services = true;
                    this.getInfo();
                }
                if (id == 2) {
                    this.contact = true;
                }
            },
            getInfo() {
                axios
                    .post(
                        `${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?pageType=${this.PageType}&culture=${language}`
                    )
                    .then((response) => {
                        this.info = response.data;

                        if (this.pageLoad == true || this.tabClicked) {
                            this.filterData();
                        }

                        for (let item of this.info.Categories) {
                            this.$set(item, "checked", false);
                            item.SubCategories = item.SubCategories.map((str, index) => ({
                                value: str,
                                id: index + 1,
                                checked: false,
                            }));
                        }

                        for (let item of this.info.Sectors) {
                            this.$set(item, "checked", false);
                            item.Department = item.Department.map((str, index) => ({
                                value: str,
                                id: index + 1,
                                checked: false,
                            }));
                        }

                        for (let item of this.info.HealthProducts) {
                            this.$set(item, "checked", false);
                        }

                        for (let item of this.info.Functions) {
                            this.$set(item, "checked", false);
                        }

                        this.pageLoad = false;
                        this.tabClicked = false;
                    });
            },
            filterData() {
                this.isAjaxLoading = true;
                //debugger
                this.servicesNoData = false;
                this.specializationsNoData = false;
                this.contactNoData = false;

                this.data = {
                    Specializations: [],
                    Services: [],
                    Contact: [],
                    Brief: "",
                    Id: "",
                    Name: "",
                };

                if (this.searchClicked || this.tarckApplyFilter == true) {
                    this.pageNumber = 1;
                    this.filteredData.Services = [];
                }

                if (this.tarckApplyFilter) {
                    if (window.innerWidth > 1025) {
                        this.apiCallLoader = true;
                    }
                }

                if (this.tabClicked) {
                    this.pageNumber = 1;
                    this.reinitFilter += 1;
                    this.filteredData.Services = [];
                    this.searchWord = "";
                    this.datestart = "";
                    this.dateend = "";
                    this.cateArr = [];
                    this.healthArr = [];
                    this.funcArr = [];
                    this.subArr = [];
                    this.depArr = [];
                    this.sectorArr = [];
                }

                let axiosData = {
                    PageType: this.PageType,
                    SelectedItemId: this.sectorId, //item id of slider
                    Text: this.searchWord,
                    PageNumber: this.pageNumber,
                    DateFrom: this.datestart, //js Date
                    DateTo: this.dateend,
                    Categories: this.cateArr,
                    HealthProducts: this.healthArr,
                    Functions: this.funcArr,
                    SubCategories: this.subArr,
                    Departments: this.depArr,
                    Sectors: this.sectorArr
                };


                axios
                    .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, axiosData)
                    .then((response) => {
                        this.apiCallLoader = false;
                        this.isAjaxLoading = false;

                        this.tabClicked = false;
                        this.tarckApplyFilter = false;
                        this.searchClicked = false;

                        this.data = response.data;


                        //check if services
                        if (this.data.Services.length != 0) {
                            this.slice();
                        } else {
                            if (this.filteredData.Services.length != 0) {
                                this.servicesNoData = false;
                            } else {
                                this.servicesNoData = true;
                            }
                        }

                        if (this.data.Contact.length != 0) {
                            this.contactNoData = false;
                        } else {
                            this.contactNoData = true;
                        }

                        //check if RulesAndRegulations
                        if (this.data.Specializations.length != 0) {
                            this.specializationsNoData = false;
                        } else {
                            this.specializationsNoData = true;
                        }
                    })
                    .catch(() => { });
            },
            slice() {
                this.filteredData.Services = this.filteredData.Services.concat(
                    this.data.Services
                );
            },
            checkTrigger() {
                const options = {
                    threshold: 0.1,
                };
                const checker = document.querySelector(".footer");
                const infiniteScroll = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (this.services && this.data.Services.length != 0) {
                                this.isAjaxLoading = true;
                                if (window.innerWidth > 1025) {
                                    this.apiCallLoader = true;
                                }
                                setTimeout(() => {
                                    this.pageNumber += 1;
                                    this.filterData();
                                    this.isAjaxLoading = false;
                                }, 500);
                            }
                        }
                    });
                };

                const observer = new IntersectionObserver(infiniteScroll, options);
                observer.observe(checker);
            },
        },
        mounted() {
            document.querySelector(".register-page-form__loader").style.display =
                "none";
            if (window.innerWidth < 768) {
                this.mobileView = true;
            }

            this.serviceObj = {
                ServiceCost: this.ServiceCost,
                CentralAdministration: this.CentralAdministration,
                PublicAdministration: this.PublicAdministration,
                Specialization: this.Specialization,
                Cosmetic: this.Cosmetic,
                SecondaryCategory: this.SecondaryCategory,
                Category: this.Category,
            };

            this.getInfo();
            this.checkTrigger();
        },
    };
</script>
